export default { // Screens Names Provided By Triskele
  dashboard: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Client Dashboard (Clinician View)'
  },
  calendar: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Client Dashboard Calendar to Select New Period'
  },
  recommendation: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Clinician Recommendations'
  },
  profileHeader: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Client Profile'
  },
  master: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Master',
    ScreenName: 'Master'
  },
  candidate: {
    ScreenId: '3_PPrDdDd01',
    Application: 'Prism - Admin',
    ScreenName: 'Field Candidate Mapping List'
  },
  adminAccess: {
    ScreenId: '3_PPrAdRl01',
    Application: 'Prism - Admin',
    ScreenName: 'Admin Role Check'
  },
  adminUsers: {
    ScreenId: '3_PPrAdUs01',
    Application: 'Prism - Admin',
    ScreenName: 'Users & Roles'
  },
  adminClients: {
    ScreenId: '3_PPrAdCl01',
    Application: 'Prism - Admin',
    ScreenName: 'Clients (Admin)'
  },
  adminProviders: {
    ScreenId: '3_PPrAdPr01',
    Application: 'Prism - Admin',
    ScreenName: 'Providers (Admin)'
  },
  adminActivity: {
    ScreenId: '3_PPrAdAc01',
    Application: 'Prism - Admin',
    ScreenName: 'Activity Log'
  },
  adminDashboard: {
    ScreenId: '3_PPrAdDb01',
    Application: 'Prism - Admin',
    ScreenName: 'Admin Dashboard'
  }
};
